const INITIAL_STATE = {
  file: null,
  loading: false,
  error: null,
  type: null,
  key: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'UPLOAD_FILE_REQUEST':
      return {
        ...state,
        loading: true,
        file: null,
        type: action.payload.type,
        key: action.payload.key,
        error: null,
      };
    case 'UPLOAD_FILE_SUCCESS':
      return {
        ...state,
        loading: false,
        file: action.payload,
      };
    case 'UPLOAD_FILE_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case 'LOGOUT':
      return INITIAL_STATE;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/upload.js